module.exports = __webpack_public_path__ + "static/img/Hitachi.ed6708c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/Hitachi.png
// module id = j91/
// module chunks = 0